
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <h2><span class="fontIcon"></span> {{ msg }}</h2>
      </div>
      <div v-if="showFilter" class="col-md-8 text-right">
        <div class="filterOrdersWrapper">
          <ul>
            <li :class="{active: activeBtn === 'all' }"><button @click="filterOrders('all')" class="btn btn-primary">Alla</button></li>
            <li :class="{active: activeBtn === 'ny' }"><button @click="filterOrders('ny')" class="btn btn-primary">Nya</button></li>
            <li :class="{active: activeBtn === 'uppdaterad' }"><button @click="filterOrders('uppdaterad')" class="btn btn-primary">Uppdaterade</button></li>
            <li :class="{active: activeBtn === 'aktiv' }"><button @click="filterOrders('aktiv')" class="btn btn-primary">Aktiva</button></li>
            <li :class="{active: activeBtn === 'avslutad' }"><button @click="filterOrders('avslutad')" class="btn btn-primary">Avslutade</button></li>
            <li :class="{active: activeBtn === 'fakturerad' }"><button @click="filterOrders('fakturerad')" class="btn btn-primary">Fakturerade</button></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table-hover orderList" v-if="orders">
            <thead>
              <tr>
                <th scope="col">Status</th>
                <th scope="col">Orderdatum</th>
                <th scope="col">OrderId</th>
                <th scope="col">Kund</th>
                <th scope="col">Leveransställe</th>
                <th scope="col">Produkt</th>
                <th scope="col">Kvantitet</th>
              </tr>
            </thead>
            <tbody>
              <tr :class="order.state" class="orderListItem" v-for="(order) in orders" :key="order.id" v-on:click="orderDetails(order)">
                <td data-label="Status">{{order.state}}</td>
                <td data-label="Orderdatum">
                  <span v-if="order.data.DateLoadingEarly">{{order.data.DateLoadingEarly}}</span>
                  <span v-else>{{ formatDate(order.createdAt) }}</span>
                </td>
                <td data-label="Orderid">{{setOrderId(order)}}</td>
                <td data-label="Kund">{{ getCustomer(order.data.kund)}}</td>
                <td data-label="Levställe">
                  <span v-if="order.data.CustomerPlaces && Array.isArray(order.data.CustomerPlaces) === false" >{{ order.data.customerPlaceName }}</span>
                  <span v-else-if="order.data.DeliveryPlaceCity">{{ order.data.DeliveryPlaceCity }}</span>
                  <span v-else-if="order.data.deliveryPlaces">{{ order.data.deliveryPlaces }}</span>
                  <span v-else-if="order.data.CustomerPlacesDropDown">{{ getCustomerPlace(order.data.CustomerPlacesDropDown) }}</span>
                </td>
                <td data-label="Produkt">
                  <span v-if="order.data.ItemId">{{order.data.ItemId}}</span>
                  <span v-else-if="order.data.productId">{{order.data.productId}}</span>
                  <span v-else>Timkörning</span>
                </td>
                <td data-label="Kvantitet"><span v-if="order.data.Quantity">{{parseFloat(order.data.Quantity.replace(',','.')).toFixed(2).toLocaleString()}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'OrderList',
  data () {
    return {
      msg: 'Aktuella ordrar',
      orders: [],
      orderTypes: [],
      customers: [],
      customerPlaces: []
    }
  },
  props: {
    needsAttention: Boolean,
    limit: Number,
    showFilter: true,
    userCustomerId: null
  },
  components: {
    'moment': moment
  },
  async mounted () {
    var response = await this.getOrders()
    this.orders = response.orders
    this.customers = response.customers
    this.customerPlaces = response.customerPlaces
    this.orderTypes = await this.getOrderTypes()
  },
  methods: {
    setOrderId (order) {
      let newId = ''
      if (order.type === 'feralco') {
        newId = order.data.SalesId
      } else if (order.type === 'feralcoIntern') {
        newId = order.data.fraktsedelNr
      } else {
        newId = order.id
      }

      return newId
    },
    formatDate (theDate) {
      var formattedDate = moment(String(theDate)).format('YYYY-MM-DD')
      return formattedDate
    },
    async orderDetails (order) {
      let schema = await this.$http.get('/api/orders/schema/' + order.type)
      if (order.type === 'feralco') {
        this.$router.push({ name: 'FeralcoOrdersDetails', params: { id: order.id, order: order, schema: schema.data.schema } })
      } else if (order.type === 'feralcoIntern') {
        this.$router.push({ name: 'FeralcoInternOrderDetails', params: { id: order.id, order: order, schema: schema.data.schema } })
      } else {
        this.$router.push({ name: 'OrderDetails', params: { id: order.id, order: order, schema: schema.data.schema } })
      }
    },
    async getOrders () {
      if (this.$props.userCustomerId !== 'null' && this.$props.userCustomerId) {
        let response = await this.$http.get('/api/orders/by-user/' + this.$props.userCustomerId)
        return response.data
      } else if (this.$props.needsAttention) {
        let response = await this.$http.get('/api/orders/attention/limit/' + this.$props.limit)
        return response.data
      } else if (this.$props.limit) {
        let response = await this.$http.get('/api/orders/limit/' + this.$props.limit)
        return response.data
      } else {
        let response = await this.$http.get('/api/orders')
        return response.data
      }
    },
    async getOrderTypes () {
      let response = await this.$http.get('/api/orders/types')
      return response.data
    },
    getCustomer (customerId) {
      var customers = this.customers
      var customer = customers.find(customer => {
        return customer.id === customerId
      })
      if (customer) {
        return customer.data.name
      } else {
        return null
      }
    },
    getCustomerPlace (customerPlaceId) {
      var customerPlaces = this.customerPlaces
      var customerPlace = customerPlaces.find(customerPlace => {
        return customerPlace.id === customerPlaceId
      })
      return customerPlace.data.name
    },
    getCustomerName (CustomerId) {
      this.$http
        .get('/api/customers/' + CustomerId)
        .then(response => {
          var customer = response.data.customer
          return customer.name
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/OrderList.vue